import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Translator } from './translator';

const Questionnaire = () => {
  const navigate = useNavigate();
  const { translateText, lang } = Translator();

  const baseText = {
    text1: "Devi fornire il consenso per partecipare.",
    text2: "Grazie per la tua partecipazione!",
    text3: "Errore durante l'invio del questionario. Riprova più tardi.",
    text4: "Errore di rete durante l'invio del questionario.",
    text5: "Te.C.H-e Technology for Cultural Heritage",
    text6: "Gent.mo/ma,",
    text7: 'Il questionario che stai per compilare fa parte di un ampio progetto di ricerca denominato "Te.C.H.e. - Technology for Cultural Heritage", che coinvolge Emozionarti s.r.l. e l’Università degli Studi di Napoli Federico II. Obiettivo del progetto è quello di valutare le preferenze degli intervistati rispetto a possibili tour digitali con esperienze interattive. Per questo motivo ti chiediamo gentilmente di dedicare 10 minuti del tuo tempo per la buona riuscita della ricerca. Ti assicuriamo che i dati forniti saranno trattati nel pieno rispetto della legge sulla privacy (d.l. 196/2003). Nel ringraziarti per la tua preziosa collaborazione, ti auguriamo una buona giornata.',
    text8: "CONSENSO INFORMATO",
    text9: "Prima di decidere liberamente se vuoi partecipare a questo studio, compilando il questionario, ti chiediamo di LEGGERE ATTENTAMENTE questo consenso informato.",
    text10: "In linea con il Codice Etico dell’Associazione Italiana di Psicologia, ti ricordiamo che:",
    text11: "- ogni partecipante è libero/a di chiedere chiarimenti sulla procedura di raccolta dati e su qualsiasi aspetto della ricerca;",
    text12: "- ogni partecipante è libero/a di non continuare la compilazione del questionario in qualsiasi momento;",
    text13: "- i dati personali raccolti non verranno trasmessi a persone non direttamente coinvolte nella ricerca;",
    text14: "- i dati personali raccolti verranno elaborati in forma anonima;",
    text15: "- i risultati verranno presentati in forma aggregata e con ogni cautela necessaria a evitare la identificabilità dei partecipanti;",
    text16: "Per partecipare alla ricerca occorre:",
    text17: "- aver letto con attenzione tutti i punti precedenti;",
    text18: "- dare il proprio consenso a partecipare alla ricerca attraverso la compilazione del questionario.",
    text19: 'Se sei d\'accordo con tutti i punti sopra elencati indica "ACCONSENTE".',
    text20: "✅ Acconsente",
    text21: "❌ Non acconsente",
    text22: "🧭 Sezione 1: Profilo del turista",
    text23: "1.1 Quanto sei disposto a muoverti dal luogo in cui risiedi per andare in vacanza?",
    text24: '1.2 Come organizzi generalmente la vacanza?',
    text25: '1.3 Preferisci acquistare online?',
    text26: '1.4 Quante notti ti fermi solitamente durante un viaggio?',
    text27: '1.5 Attività preferite durante il viaggio',
    text27_2: "(puoi selezionare più opzioni)",
    text28: '1.6 Con chi viaggi di solito?',
    text29: '1.7 Quanto spendi mediamente per i tuoi viaggi?',
    text30: '1.8 Cosa compri generalmente come ricordo del tuo viaggio?',
    text31: '1.9 Preferisci approfondire i luoghi che visiti?',
    text32: '1.10 Qual è la frequenza delle tue gite turistiche?',
    text33: '1.11 Qual è la tua categoria di interesse principale turistico-culturale? (solo una preferenza)',
    text34: '🎮 Sezione 2: Analisi delle preferenze per esperienze interattive',
    text35: 'Esprimi il tuo livello di gradimento attribuendo un valore da 1 a 10, dove 1 significa che non ti piace per niente e 10 che ti piace moltissimo.',
    text36: '📊 Sezione 3: Dati socio-demografici',
    text37: 'GRAZIE PER L’ATTENZIONE. Per avere ulteriori informazioni in merito alla ricerca puoi contattare Emozionarti s.r.l. (responsabile di questo studio) all’indirizzo mail: emozionartisrl@gmail.com',
    text38: "1.5 Attività preferite durante il viaggio",
    text39: "(La Realtà Aumentata (AR) sovrappone elementi digitali al mondo reale, mentre la Realtà Virtuale (VR) crea un ambiente completamente simulato.)",
    text40: "2.1 Quanto gradiresti un'esperienza interattiva incentrata su attività di gamification (es. caccia al tesoro)?",
    text41: "2.2 Quanto gradiresti un'esperienza interattiva incentrata sulla tecnica di produzione tipica di olio in luoghi di antica tradizione?",
    text42: "2.3 Quanto gradiresti un'esperienza interattiva incentrata sulla tecnica di creazione artistica tipica locale?",
    text43: "2.4 Quanto gradiresti un'esperienza interattiva incentrata sulla tecnica di preparazione di piatti tipici locali?",
    text44: "2.5 Quanto gradiresti un'esperienza interattiva incentrata sulla tecnica di lavorazione della pasta a mano tipica di lunga tradizione?",
    text45: "2.6 Quanto gradiresti un'esperienza interattiva incentrata su Digital Art - NFT legati a tipicità locali?",
    text46: "2.7 Quanto gradiresti un'esperienza interattiva di qualsiasi tipo?",
    text47: "3.1 Genere",
    text48: "3.2 Età (in anni)",
    text49: "3.3 Stato civile",
    text50: "3.4 Livello di istruzione più alto completato",
    text51: "3.5 Situazione occupazionale",
    text52: "3.6 Residenza",
    text53: "📩 Invia Questionario",
    text54: "Per avere ulteriori informazioni in merito alla ricerca puoi contattare Emozionarti s.r.l. (responsabile di questo studio) all’indirizzo mail:",
    text55: "GRAZIE PER L’ATTENZIONE",
    text56: "poco",
    text57: "abbastanza",
    text58: "molto",
    text59: "fai da te",
    text60: "agenzia di viaggio",
    text61: "altro",
    text62: "si",
    text63: "no",
    text64: "una",
    text65: "due",
    text66: "tre",
    text67: "oltre tre",
    text68: "visitare musei e siti storici",
    text69: "escursioni nella natura",
    text70: "partecipare a festival o eventi locali",
    text71: "provare la cucina/degustare prodotti tipici",
    text72: "esperienze in AR o VR",
    text73: "solo",
    text74: "amici",
    text75: "famiglia",
    text76: "colleghi",
    text77: "coppia",
    text78: "100-300 euro",
    text79: "300-500 euro",
    text80: "oltre 500 euro",
    text81: "abbigliamento",
    text82: "oggettistica",
    text83: "prodotti alimentari",
    text84: "digital Art - NFT legato a tipicità locali",
    text85: "altro",
    text86: "si, con guida turistica",
    text87: "si, con guida digitale",
    text88: "si, mi documento autonomamente",
    text89: "no",
    text90: "1-2 volte all’anno",
    text91: "3-5 volte all’anno",
    text92: "più di 5 volte all’anno",
    text93: "paesaggio e cibo",
    text94: "arte e creatività",
    text95: "feste e rituali",
    text96: "borghi e tradizioni",
    text97: "viticoltura e vinificazione",
    text98: "fiere e mercati locali",
    text99: "altro",
    text100: "maschio",
    text101: "femmina",
    text102: "preferisco non specificarlo",
    text103: "celibe/nubile",
    text104: "sposato/a",
    text105: "separato/a",
    text106: "vedovo/a",
    text107: "licenza elementare (basso)",
    text108: "licenza media inferiore (basso)",
    text109: "licenza media superiore (medio)",
    text110: "laurea triennale (medio)",
    text111: "laurea magistrale (alto)",
    text112: "post-laurea (alto)",
    text113: "studente",
    text114: "lavoratore dipendente",
    text115: "lavoratore autonomo",
    text116: "disoccupato",
    text117: "pensionato",
    text118: "Campania",
    text119: "altra regione italiana",
    text120: "estero"


    

  };
    
  const [translatedText, setTranslatedText] = useState(baseText);
  useEffect(() => {
  const translateAll = async () => {
      const entries = Object.entries(baseText);
      const translatedEntries = await Promise.all(
      entries.map(async ([key, value]) => [key, await translateText(value)])
      );
      setTranslatedText(Object.fromEntries(translatedEntries));
  };

  translateAll();
  }, [lang]);    
    
  const [consent, setConsent] = useState(null);
  const [formData, setFormData] = useState({
    movement: "", 
    vacationMethod: "", 
    buyOnline: "", 
    nights: "",
    activities: [], 
    companions: "", 
    budget: "", 
    souvenir: "",
    exploration: "", 
    frequency: "",
    interest: "",
    q2_1: "", q2_2: "", q2_3: "", q2_4: "", q2_5: "", q2_6: "", q2_7: "",
    gender: "",
    age: "",
    maritalStatus: "",
    education: "",
    occupation: "",
    residence: ""
  });

  const handleChange = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const handleMultiple = (key, value) => {
    setFormData(prev => {
      const current = prev[key];
      return {
        ...prev,
        [key]: current.includes(value)
          ? current.filter(v => v !== value)
          : [...current, value]
      };
    });
  };

const handleSubmit = async () => {
  if (consent !== "yes") {
    alert(translatedText.text1);
    return;
  }

  try {
    const response = await fetch("https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/saveQuestionnaire/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const result = await response.json();

    if (result === 1) {
      alert(translatedText.text2);
      navigate("/");
    } else {
      alert(translatedText.text3);
    }
  } catch (error) {
    console.error("Error:", error);
    alert(translatedText.text4);
  }
};


  return (
  <div className="max-w-4xl mx-auto px-6 py-10 bg-white shadow rounded-md text-gray-800">
    {consent !== "yes" ? (
      <>
        <h1 className="text-3xl font-bold mb-6 text-center">{translatedText.text5}</h1>

        {/* Intro */}
        <p className="mb-2 font-medium">{translatedText.text6}</p>
        <p className="mb-4">
          {translatedText.text7}
        </p>

        <hr className="my-6 border-gray-400" />

        <h2 className="text-black text-xl font-semibold mb-4">{translatedText.text8}</h2>

        <p className="mb-4">
          {translatedText.text9}
        </p>

        <p className="mb-2"> {translatedText.text10} </p>
        <div className="mb-4 space-y-2">
          <p> {translatedText.text11} </p>
          <p> {translatedText.text12} </p>
          <p> {translatedText.text13} </p>
          <p> {translatedText.text14} </p>
          <p> {translatedText.text15} </p>
        </div>

        <p className="mb-2"> {translatedText.text16} </p>
        <div className="mb-4 space-y-2">
          <p> {translatedText.text17} </p>
          <p> {translatedText.text18} </p>
        </div>

        <p className="mb-2"> {translatedText.text19} </p>

        <div className="flex justify-center gap-10 mt-6">
          <button
            type="button"
            onClick={() => setConsent("yes")}
            className={`px-6 py-2 rounded-full border font-semibold transition-colors ${
              consent === "yes"
                ? "bg-green-600 text-white border-green-700"
                : "bg-white text-green-700 border-green-500 hover:bg-green-100"
            }`}
          >
            {translatedText.text20}
          </button>
          <button
            type="button"
            onClick={() => setConsent("no")}
            className={`px-6 py-2 rounded-full border font-semibold transition-colors ${
              consent === "no"
                ? "bg-red-600 text-white border-red-700"
                : "bg-white text-red-700 border-red-500 hover:bg-red-100"
            }`}
          >
            {translatedText.text21}
          </button>
        </div>
      </>
    ) : (
      <>
        {/* Questions */}
        <h2 className="text-2xl font-bold mb-8 text-black"> {translatedText.text22} </h2>
        
          {/* 1.1 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2"> {translatedText.text23} </p>
            <div className="space-y-2">
              {["text56", "text57", "text58"].map(key => (
                <label key={key} className="flex items-center gap-2">
                  <input type="radio" name="movement" onChange={() => handleChange("movement", translatedText[key])} />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 1.2 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2"> {translatedText.text24} </p>
            <div className="space-y-2">
              {["text59", "text60", "text61"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="vacationMethod"
                    onChange={() => handleChange("vacationMethod", translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 1.3 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2"> {translatedText.text25} </p>
            <div className="space-y-2">
              {["text62", "text63"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="buyOnline"
                    onChange={() => handleChange("buyOnline", translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 1.4 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2"> {translatedText.text26} </p>
            <div className="space-y-2">
              {["text64", "text65", "text66", "text67"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="nights"
                    onChange={() => handleChange("nights", translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 1.5 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2"> {translatedText.text27} <span className="text-sm font-normal">{translatedText.text27_2}</span></p>
            <div className="space-y-2">
              {["text68", "text69", "text70", "text71", "text72"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    onChange={() => handleMultiple("activities", translatedText[key])}
                    checked={formData.activities.includes(translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
            <p className="text-xs italic mt-2 text-gray-600">
              {translatedText.text39}
            </p>
          </div>

          {/* 1.6 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">{translatedText.text28}</p>
            <div className="space-y-2">
              {["text73", "text74", "text75", "text76", "text77"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="companions"
                    onChange={() => handleChange("companions", translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 1.7 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">{translatedText.text29}</p>
            <div className="space-y-2">
              {["text78", "text79", "text80"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="budget"
                    onChange={() => handleChange("budget", translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 1.8 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2"> {translatedText.text30}</p>
            <div className="space-y-2">
              {["text81", "text82", "text83", "text84", "text85"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="souvenir"
                    onChange={() => handleChange("souvenir", translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>


          {/* 1.9 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">{translatedText.text31}</p>
            <div className="space-y-2">
              {["text86", "text87", "text88", "text89"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="exploration"
                    onChange={() => handleChange("exploration", translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>


          {/* 1.10 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">{translatedText.text32}</p>
            <div className="space-y-2">
              {["text90", "text91", "text92"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="frequency"
                    onChange={() => handleChange("frequency", translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>


          {/* 1.11 */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">
              {translatedText.text33} <span className="text-sm font-normal">(solo una preferenza)</span>
            </p>
            <div className="space-y-2">
              {["text93", "text94", "text95", "text96", "text97", "text98", "text99"].map((key) => (
                <label key={key} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="interest"
                    onChange={() => handleChange("interest", translatedText[key])}
                  />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>



          {/* Section 2 */}
          <h2 className="text-2xl font-bold mt-12 mb-4 text-black">
            {translatedText.text34}
          </h2>
          <p className="mb-6 text-gray-700">{translatedText.text35}</p>

          {/* 2.1 */}
          <div className="mb-6">
            <label className="block font-semibold mb-2">
              {translatedText.text40}
            </label>
            <input
              type="number"
              min="1"
              max="10"
              className="w-full border rounded px-3 py-2"
              onChange={(e) => handleChange("q2_1", e.target.value)}
            />
          </div>

          {/* 2.2 */}
          <div className="mb-6">
            <label className="block font-semibold mb-2">
              {translatedText.text41}
            </label>
            <input
              type="number"
              min="1"
              max="10"
              className="w-full border rounded px-3 py-2"
              onChange={(e) => handleChange("q2_2", e.target.value)}
            />
          </div>

          {/* 2.3 */}
          <div className="mb-6">
            <label className="block font-semibold mb-2">
              {translatedText.text42}
            </label>
            <input
              type="number"
              min="1"
              max="10"
              className="w-full border rounded px-3 py-2"
              onChange={(e) => handleChange("q2_3", e.target.value)}
            />
          </div>

          {/* 2.4 */}
          <div className="mb-6">
            <label className="block font-semibold mb-2">
              {translatedText.text43}
            </label>
            <input
              type="number"
              min="1"
              max="10"
              className="w-full border rounded px-3 py-2"
              onChange={(e) => handleChange("q2_4", e.target.value)}
            />
          </div>

          {/* 2.5 */}
          <div className="mb-6">
            <label className="block font-semibold mb-2">
              {translatedText.text44}
            </label>
            <input
              type="number"
              min="1"
              max="10"
              className="w-full border rounded px-3 py-2"
              onChange={(e) => handleChange("q2_5", e.target.value)}
            />
          </div>

          {/* 2.6 */}
          <div className="mb-6">
            <label className="block font-semibold mb-2">
              {translatedText.text45}
            </label>
            <input
              type="number"
              min="1"
              max="10"
              className="w-full border rounded px-3 py-2"
              onChange={(e) => handleChange("q2_6", e.target.value)}
            />
          </div>

          {/* 2.7 */}
          <div className="mb-6">
            <label className="block font-semibold mb-2">
              {translatedText.text46}
            </label>
            <input
              type="number"
              min="1"
              max="10"
              className="w-full border rounded px-3 py-2"
              onChange={(e) => handleChange("q2_7", e.target.value)}
            />
          </div>


          {/* Section 3 */}
          <h2 className="text-2xl font-bold mt-12 mb-6 text-black">{translatedText.text36}</h2>

          {/* 3.1 Genere */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">{translatedText.text47}</p>
            <div className="space-y-2">
              {["text100", "text101", "text102"].map(key => (
                <label key={key} className="flex items-center gap-2">
                  <input type="radio" name="gender" onChange={() => handleChange("gender", translatedText[key])} />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 3.2 Età */}
          <div className="mb-6">
            <label className="block font-semibold text-lg mb-2">{translatedText.text48}</label>
            <input
              type="number"
              min="0"
              max="120"
              className="w-full border rounded px-3 py-2"
              onChange={(e) => handleChange("age", e.target.value)}
            />
          </div>

          {/* 3.3 Stato civile */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">{translatedText.text49}</p>
            <div className="space-y-2">
              {["text103", "text104", "text105", "text106"].map(key => (
                <label key={key} className="flex items-center gap-2">
                  <input type="radio" name="maritalStatus" onChange={() => handleChange("maritalStatus", translatedText[key])} />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 3.4 Livello di istruzione */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">{translatedText.text50}</p>
            <div className="space-y-2">
              {["text107", "text108", "text109", "text110", "text111", "text112"].map(key => (
                <label key={key} className="flex items-center gap-2">
                  <input type="radio" name="education" onChange={() => handleChange("education", translatedText[key])} />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 3.5 Situazione occupazionale */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">{translatedText.text51}</p>
            <div className="space-y-2">
              {["text113", "text114", "text115", "text116", "text117"].map(key => (
                <label key={key} className="flex items-center gap-2">
                  <input type="radio" name="occupation" onChange={() => handleChange("occupation", translatedText[key])} />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 3.6 Residenza */}
          <div className="mb-6">
            <p className="font-semibold text-lg mb-2">{translatedText.text52}</p>
            <div className="space-y-2">
              {["text118", "text119", "text120"].map(key => (
                <label key={key} className="flex items-center gap-2">
                  <input type="radio" name="residence" onChange={() => handleChange("residence", translatedText[key])} />
                  <span>{translatedText[key]}</span>
                </label>
              ))}
            </div>
          </div>

          <p className="mt-10 font-bold">{translatedText.text55}</p>
          <p className="text-sm mt-2 text-gray-700">
            {translatedText.text54}{" "}
            <a href="mailto:emozionartisrl@gmail.com" className="text-blue-600 underline">emozionartisrl@gmail.com</a>
          </p>










        <div className="flex justify-center">
          <button className="bg-[#324B8E] text-white px-4 py-2 rounded mt-6" onClick={handleSubmit}>
            {translatedText.text53}
          </button>
        </div>
      </>
    )}
  </div>
);


};

export default Questionnaire;
